import { Store } from "@ngrx/store";
import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { resetUser } from "../store/auth/auth.actions";
import { toggleAnimation } from "../shared/animations";
import { NavigationEnd, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { AppService } from "../shared/services/app.service";
import { take } from "rxjs";
import { UserService } from "../components/users/service/user.service";

@Component({
  selector: "header",
  templateUrl: "./header.html",
  animations: [toggleAnimation],
  standalone: false,
})
export class HeaderComponent {
  store: any;
  search = false;
  user: any;

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router,
    private appSetting: AppService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
  ) {
    this.initStore();
  }

  async initStore() {
    this.storeData
      .select(d => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  ngOnInit() {
    this.setActiveDropdown();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActiveDropdown();
      }
    });

    const user$ = this.storeData.select(d => d.auth);
    user$.subscribe((auth: { user: any }) => {
      this.user = auth.user;
    });
  }

  setActiveDropdown() {
    const selector = document.querySelector(
      `ul.horizontal-menu a[routerLink="${window.location.pathname}"]`,
    );
    if (selector) {
      selector.classList.add("active");
      const all: any = document.querySelectorAll(
        "ul.horizontal-menu .nav-link.active",
      );
      for (let i = 0; i < all.length; i++) {
        all[0]?.classList.remove("active");
      }
      const ul: any = selector.closest("ul.sub-menu");
      if (ul) {
        let ele: any = ul.closest("li.menu").querySelectorAll(".nav-link");
        if (ele) {
          ele = ele[0];
          setTimeout(() => {
            ele?.classList.add("active");
          });
        }
      }
    }
  }

  signOut() {
    if (this.user) {
      this.userService.updateUser(this.user.id, { ...this.user }).pipe(take(1)).subscribe(() => {
        resetUser();
      });
    }
    else {
      resetUser();
    }
  }

  changeLanguage(item: any) {
    this.translate.use(item.code);
    this.appSetting.toggleLanguage(item);
    if (this.store.locale?.toLowerCase() === "ae") {
      this.storeData.dispatch({ type: "toggleRTL", payload: "rtl" });
    }
    else {
      this.storeData.dispatch({ type: "toggleRTL", payload: "ltr" });
    }
    window.location.reload();
  }
}
